import React, { useEffect } from 'react';
import {
  H2,
  LoadingSpinner,
  LoadingSpinnerSize,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../../core';

interface DoVerifyPatientProps {
  contactInfo: {
    mrn: string;
    dateOfBirth: string;
    contactType: string;
    patientAccessCode: string;
  };
  verifyAccessCode?: (
    mrn: string,
    dateOfBirth: string,
    contactType: string,
    patientAccessCode: string
  ) => Promise<boolean | undefined>;
  onSuccess: () => void;
  onError: () => void;
}

const DoVerifyPatient: React.FC<DoVerifyPatientProps> = (
  props: DoVerifyPatientProps
) => {
  useEffect(() => {
    const verifyCode = async () => {
      if (props.verifyAccessCode === undefined) {
        props.onError();
        return;
      }

      const result = await props.verifyAccessCode(
        props.contactInfo.mrn,
        props.contactInfo.dateOfBirth,
        props.contactInfo.contactType,
        props.contactInfo.patientAccessCode
      );
      
      if (result === undefined || result === false) {
        props.onError();
        return;
      }

      props.onSuccess();
    };

    verifyCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StackedColumn fillHeight={true} spacing={StackedColumnSpacing.Wide}>
      <H2 text="Verifying Code" />
      <LoadingSpinner
        label="Loading, please wait..."
        size={LoadingSpinnerSize.Medium}
      />
    </StackedColumn>
  );
};

export default DoVerifyPatient;
